import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class File extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        href: {
          default: null,
        },
        name: {
          default: null,
        },
        type: {
          default: null,
        },
        size: {
          default: null,
        },
        file: {
          default: null,
        },
      },
      group: 'block',
      isAtom: true,
      parseDOM: [
        {
          tag: 'div.lygo-file',
          getAttrs: (dom) => {
            const file = (dom as HTMLElement).getElementsByTagName('a')[0];
            return {
              href: file.getAttribute('href'),
              name: file.getAttribute('name'),
              type: file.getAttribute('type'),
              size: file.getAttribute('size'),
            };
          },
        },
      ],
      toDOM: (node) => {
        let href = node?.attrs?.href;
        return href
          ? ['div', { class: 'flex justify-center mt-16 lygo-file' }, ['a', { ...node.attrs }]]
          : ['div'];
      },
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  plugins = plugins;
}
